import { render, staticRenderFns } from "./EditSalesDeliveryComponent.vue?vue&type=template&id=1f827af2"
import script from "./EditSalesDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./EditSalesDeliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports